import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { visitAPI } from '../../services/api';
import toast from 'react-hot-toast';
import VisitForm from './VisitForm';
import VisitList from './VisitList';

const MyVisits = () => {
  const { user } = useAuth();
  const [visits, setVisits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingVisit, setEditingVisit] = useState(null);
  const [filters, setFilters] = useState({
    dateFrom: '',
    dateTo: '',
    regionId: '',
    visitTypeId: ''
  });

  useEffect(() => {
    fetchVisits();
  }, [filters]);

  const fetchVisits = async () => {
    try {
      setLoading(true);
      const params = {};
      if (filters.dateFrom) params.dateFrom = filters.dateFrom;
      if (filters.dateTo) params.dateTo = filters.dateTo;
      if (filters.regionId) params.regionId = filters.regionId;
      if (filters.visitTypeId) params.visitTypeId = filters.visitTypeId;
      
      const response = await visitAPI.getAll(params);
      setVisits(response.data.data || []);
    } catch (error) {
      console.error('Error fetching visits:', error);
      toast.error('Failed to load visits');
    } finally {
      setLoading(false);
    }
  };

  const handleAddVisit = () => {
    setEditingVisit(null);
    setShowModal(true);
  };

  const handleEditVisit = (visit) => {
    setEditingVisit(visit);
    setShowModal(true);
  };

  const handleDeleteVisit = async (id) => {
  if (!window.confirm('Are you sure you want to delete this visit?')) return;
    
    try {
      await visitAPI.delete(id);
      toast.success('Visit deleted successfully');
      fetchVisits();
    } catch (error) {
      console.error('Error deleting visit:', error);
      toast.error('Failed to delete visit');
    }
  };

  const handleSaveVisit = async (visitData) => {
    try {
      if (editingVisit) {
        await visitAPI.update(editingVisit.id, visitData);
        toast.success('Visit updated successfully');
      } else {
        await visitAPI.create(visitData);
        toast.success('Visit added successfully');
      }
      setShowModal(false);
      fetchVisits();
    } catch (error) {
      console.error('Error saving visit:', error);
      toast.error(error.response?.data?.message || 'Failed to save visit');
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">My Visits</h1>
          <p className="text-gray-600 mt-1">
            {user?.role === 'admin' ? 'All team visits' : 'Doctor and chemist calls you\'ve logged'}
          </p>
        </div>
        <button
          onClick={handleAddVisit}
          className="bg-teal-600 text-white px-4 py-2 rounded-lg hover:bg-teal-700 transition-colors flex items-center gap-2"
        >
          <i className="ti ti-plus" />
          Log Visit
        </button>
      </div>

      <VisitList
        visits={visits}
        loading={loading}
        onEdit={handleEditVisit}
        onDelete={handleDeleteVisit}
        filters={filters}
        setFilters={setFilters}
        isAdmin={user?.role === 'admin'}
      />

      <VisitForm
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSave={handleSaveVisit}
        visit={editingVisit}
      />
    </div>
  );
};

export default MyVisits;